import AdvertisementCookie from "components/shared/AdvertisementCookie/AdvertisementCookie";

export default class GetGPT {
  static getGPT() {
    if (AdvertisementCookie.showBannerAd()) {
      GetGPT.loadGPT();
    }
  }

  static loadGPT() {
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.async = "async";
    script.src = "https://securepubads.g.doubleclick.net/tag/js/gpt.js";

    document.head.appendChild(script);
  }
}
